// /**
//  * axios요청시 catch문 error 공통 처리 함수.
//  * @param {Object} error - axios요청시 catch문 파라미터 error
//  */
// // function commonErrorHandler(error){
// //     if (error.response) {
// //         if(error.response.data.errno === 1451) {
// //             // Cannot delete or update a parent row: a foreign key constraint fails
// //             alert(`삭제 실패! \n[사유 - 하위 테이블에서 참조하는 데이터 존재]`);
// //         }
// //     } else {
// //         // Something happened in setting up the request that triggered an Error
// //         console.log('Error', error.message);
// //     }
// // }

// // function hoho(){
// //     alert('잘됩니다.');
// // }


// export default (error) => {
//    console.log(error);
// }
var common = {
    commonErrorHandler(error) {
        // console.dir(error);
        if (error.response) {
            if (error.response.data.errno === 1451) {
                // Cannot delete or update a parent row: a foreign key constraint fails
                alert(`삭제 실패! \n[사유 - 하위 테이블에서 참조하는 데이터 존재]`);
            }
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
        }
    },
    con_test(data){
    }
}

export default common


// WEBPACK FOOTER //
// ./src/javascript/common.js